export default __webpack_public_path__ + "static/media/red_solid_star.a21f8abf.svg";